import { CommonState } from 'common/types'
import { Brands } from 'common/types/entities/store'
import { fetchStoreBrands } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'

const initialState: Brands = {
  brands: [],
  selectedBrandId: null,
  cacheParam: null,
}

const FETCH = 'store/brand/FETCH'
const SET = 'store/brand/SET'

export const fetchBrands = (curState: StateKey, storeId: string, queryParams?: any) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const cacheParam = createCacheParam(FETCH, 'fetchBrands', { curState, storeId, queryParams })
  const brandId = queryParams && queryParams['brandId'] ? queryParams['brandId'] : null
  if (isCacheHit(getState().storeBrands[curState], cacheParam)) {
    return
  }
  const brands = await fetchStoreBrands(storeId)
  dispatch({
    curState,
    cacheParam,
    brands,
    brandId,
    type: FETCH,
  })
}

export const setBrand = (curState: StateKey, brandId: string) => {
  return {
    curState,
    brandId,
    type: SET,
  }
}

const brandsReducer = (state = initialState, action): Brands => {
  switch (action.type) {
    case FETCH:
      return {
        ...initialState,
        ...action.brands,
        selectedBrandId: action.brandId,
        cacheParam: action.cacheParam,
      }
    case SET:
      return {
        ...state,
        cacheParam: null,
        selectedBrandId: action.brandId,
      }
    default:
      return state
  }
}

export default brandsReducer
